import { TSupplementaryRoles } from "../volunteer/shared/constants/roles";

export const SMALL_COLUMN_WIDTH = 94;
export const BLOCK_HEIGHT = 80;
export const BLOCK_WIDTH = 300;

export const PRIVATE_CALENDAR_LINK =
  "https://calendar.google.com/calendar/u/0?cid=Y18wMDVucGtrcDA2cDZmMmMwNjZpY2VwZXZxb0Bncm91cC5jYWxlbmRhci5nb29nbGUuY29t";
export const PUBLIC_CALENDAR_LINK =
  "https://calendar.google.com/calendar/u/0?cid=Y191ZmRkbGkyODFxdWRyNW9yaDdzaWs5cXQ2Y0Bncm91cC5jYWxlbmRhci5nb29nbGUuY29t";

export const HOURS_LIST = [
  "12am",
  "1am",
  "2am",
  "3am",
  "4am",
  "5am",
  "6am",
  "7am",
  "8am",
  "9am",
  "10am",
  "11am",
  "12pm",
  "1pm",
  "2pm",
  "3pm",
  "4pm",
  "5pm",
  "6pm",
  "7pm",
  "8pm",
  "9pm",
  "10pm",
  "11pm",
];

export const SUPPLEMENTARY_FILTER_COLOURS: Record<TSupplementaryRoles, string> =
  {
    [TSupplementaryRoles.JUDGING]: "#54C152",
    [TSupplementaryRoles.REGISTRATION]: "#CB2E2E",
    [TSupplementaryRoles.SETUP]: "#B348C8",
    [TSupplementaryRoles.CLEANUP]: "#E34B82",
    [TSupplementaryRoles.HARDWARE]: "#4B5563",
    [TSupplementaryRoles.SLEEP]: "#071995",
    [TSupplementaryRoles.PHOTOGRAPHY]: "#3D1956",
    [TSupplementaryRoles.DECOR]: "#cfa80e",
    [TSupplementaryRoles.MENTORSHIP]: "#0D9488",
    [TSupplementaryRoles.HACKY_HOUR]: "#7C3AED",
    [TSupplementaryRoles.MEETUP]: "#2563EB",
  };

export enum SCHEDULE_VIEW_TYPE {
  LIST_VIEW,
  CALENDAR_VIEW,
}
